/**
 * Generates fake data for the data grids to display the skeleton cell while the real data is fetched.
 * @param {*} columns columns of the data grid
 * @returns fake rows for the data grid
 */
export const getDataGridFakeData = (columns) => {
	let row = { isDummyRow: true };
	columns.forEach((column) => {
		row = {
			...row,
			[`${column}`]: ""
		};
	});

	const rows = Array.from({ length: 25 }, () => { return { ...row, id: Math.random(), value: "" }; });
	return rows;
};

/**
 * Custom comparator function for comparing name fields in user specific data grids.
 * @param {*} v1 first value to compare
 * @param {*} v2 second value to compare
 * @returns negative or positive number if the first value is less or greater than the second value, respectively
 */
export const customNameComparator = (v1, v2) => {
	const stringifiedV1 = JSON.stringify(v1);
	const stringifiedV2 = JSON.stringify(v2);
	if (!stringifiedV1 && !stringifiedV2) return;
	return stringifiedV1.localeCompare(stringifiedV2);
};

/**
 * Custom comparator function for comparing version fields in workstation specific data grids.
 * @param {*} v1 first value to compare
 * @param {*} v2 second value to compare
 * @returns negative or positive number if the first value is less or greater than the second value, respectively
 */
export const customVersionComparator = (v1, v2) => {
	if (!v1 || !v2) return 0;
	
	const targetVersionParts = v1.split(".").map(Number);
	const currentVersionParts = v2.split(".").map(Number);
  
	const len = Math.max(targetVersionParts.length, currentVersionParts.length);
	for (let i = 0; i < len; i++) {
		const a = targetVersionParts[i] || 0;
		const b = currentVersionParts[i] || 0;
		if (a > b) return 1;
		if (a < b) return -1;
	}
	return 0;
};